import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

export const GET_ACCOUNT_REPORT = gql`
  query GetAccountReport($id: Int!, $year: Int!) {
    getAccount(id: $id) {
      id
      business_dba
      logo
      logo_id
      stripe_balance
      payout_balances {
        total
      }
    }
    getDashboardMetrics(input: { account_id: $id, year: $year }) {
      total_platform_profit
      app_profit
      pos_profit
      events_count
    }
  }
`;

export function useGetAccountReporting(currentAccount, year, skip = false) {
  const { data, loading, error } = useQuery(GET_ACCOUNT_REPORT, {
    variables: {
      id: currentAccount,
      year: year,
    },
    fetchPolicy: 'no-cache',
    skip: !currentAccount || !year || skip,
  });

  return {
    data,
    loading,
    error,
    // Convenience accessors for the combined data
    account: data?.getAccount,
    metrics: data?.getDashboardMetrics,
  };
}
